// extracted by mini-css-extract-plugin
export default {"line":"src-components-SplitLine-css__line--694ZF"};